const FilledProfileIcon = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#0D2E68" />
    <path
      d="M17.334 18.0007V16.6673C17.334 15.96 17.053 15.2817 16.5529 
      14.7816C16.0528 14.2815 15.3745 14.0005 14.6672 14.0005H9.33361C8.62633 
      14.0005 7.94802 14.2815 7.4479 14.7816C6.94777 15.2817 6.66681 15.96 6.66681 
      16.6673V18.0007"
      stroke="#CEE8FF"
      strokeWidth="1.3334"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0004 11.3337C13.4733 11.3337 14.6672 10.1398 14.6672 8.66692C14.6672
       7.19409 13.4733 6.00012 12.0004 6.00012C10.5276 6.00012 9.33362 7.19409
       9.33362 8.66692C9.33362 10.1398 10.5276 11.3337 12.0004 11.3337Z"
      stroke="#CEE8FF"
      strokeWidth="1.3334"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FilledProfileIcon;
